import { isAndroid } from 'react-device-detect';

import { useClientHasRendered } from '../hooks';

export const useIsAndroid = (): boolean => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered && isAndroid;
};
